export default __webpack_public_path__ + "assets/enterprise-one-one-small.78ebf0c339466be64ba7ef3efdd53563.png";